import React, {ReactNode} from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import {Breakpoint, Container} from '@mui/material';
import classNames from './Layout.module.css'
import {AppHeader} from './AppHeader';
import {Loader} from "./Loader";

type LayoutProps = {
    children: ReactNode,
    chip?: string,
    isLoading?: boolean,
    isTitleHidden? :boolean,
    maxWidth?: Breakpoint
    showHeader? :boolean,
    showMenu? :boolean,
    title: string,
}

export const Layout = (props: LayoutProps) => {
    const {
        children,
        chip,
        isLoading = false,
        isTitleHidden = false,
        maxWidth,
        showHeader = false,
        showMenu = false,
        title,
    } = props

    return (
        <>
            {showHeader && (<AppHeader showMenu={showMenu} />)}

            <Container className={classNames.root} maxWidth={maxWidth}>
                {!isTitleHidden && (
                    <Stack direction="row" spacing={3} alignItems="center">
                        <Typography variant="h4" component="h1">{title}</Typography>
                        {chip && <Chip label={chip}  />}
                    </Stack>
                )}

                <div className={classNames.body}>
                    {children}
                </div>

                <Loader isVisible={isLoading} />
            </Container>
        </>

    )
}
